<template>
  <div id="app">
    <main class="l-page">
      <router-view/>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global.scss';

  .l-page {
    position: relative;
    width: 100vw;
    height: 100vh;
    max-width: $max-page-width;
    max-height: $max-page-height;
    min-height: 550px;
    margin: 0 auto;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue